"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactHookForm = require("react-hook-form");
var _texts = require("../texts");
var Button = _interopRequireWildcard(require("../buttons"));
var Input = _interopRequireWildcard(require("../inputs"));
var _util = require("../../util");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var BLOCK_CLASS = 'pf-provider-search-container';
var SearchForm = function SearchForm(_ref) {
  var onCancelClick = _ref.onCancelClick,
    onSubmit = _ref.onSubmit;
  var _useForm = (0, _reactHookForm.useForm)({
      defaultValues: {
        location: '',
        name: ''
      }
    }),
    register = _useForm.register,
    handleSubmit = _useForm.handleSubmit;
  var bem = (0, _util.klass)(BLOCK_CLASS);
  var canceClickHandler = function canceClickHandler(e) {
    e.preventDefault();
    onCancelClick(e);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: BLOCK_CLASS
  }, /*#__PURE__*/_react.default.createElement("form", {
    className: bem('form'),
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/_react.default.createElement("header", null, /*#__PURE__*/_react.default.createElement(_texts.MainHeader, null, "Find your doctor"), /*#__PURE__*/_react.default.createElement(_texts.SubHeader, null, "Enter your provider's location or name and click search to view results."), /*#__PURE__*/_react.default.createElement(Button.Link, {
    type: "button",
    className: bem('cancel-button'),
    onClick: canceClickHandler
  }, "Cancel")), /*#__PURE__*/_react.default.createElement("div", {
    className: bem('fields')
  }, /*#__PURE__*/_react.default.createElement(Input.Text, Object.assign({
    id: "location"
  }, register('location'), {
    label: "Location",
    placeholder: "Zip Code or City"
  })), /*#__PURE__*/_react.default.createElement(Input.Text, Object.assign({
    id: "name"
  }, register('name'), {
    label: "Name",
    placeholder: "Practice or Doctor Name"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: bem('submit')
  }, /*#__PURE__*/_react.default.createElement(Button.Primary, {
    type: "submit"
  }, "Search"))));
};
SearchForm.propTypes = {
  onSubmit: _propTypes.default.func.isRequired,
  onCancelClick: _propTypes.default.func
};
SearchForm.defaultProps = {
  onCancelClick: function onCancelClick() {
    return null;
  }
};
var _default = exports.default = SearchForm;
